import { Inject, Injectable } from '@angular/core';

import { IMessagingEnvironment } from '../interfaces/IMessagingEnvironment';
import { MESSAGING_CONFIG } from '../messaging-config';

@Injectable()
export class MessagingEnvironmentService {
  env: IMessagingEnvironment;

  constructor(@Inject(MESSAGING_CONFIG) config: IMessagingEnvironment) {
    this.env = config;
  }
}
